import { Logger } from './utils';

export class WidgetCommunicator {
  constructor(iframeID, params, loaderMessageListener, loaderMessageSender, debug = false) {
    this.iframeID = iframeID;
    this.city = this.extractCityParams(params);
    this.mode = params.mode;
    this.widgetInfoString = params.widget_info_string || '';
    this.widgetHeight = null;
    this.loaderMessageListener = loaderMessageListener;
    this.loaderMessageSender = loaderMessageSender;
    this.logger = new Logger(debug, `${this.iframeID} [WidgetCommunicator]`);
  }

  extractCityParams(params) {
    const cityParams = ['city_id', 'city_url', 'city_name', 'city_ascii_name', 'slug', 'city_widgetbar_text'];

    if (cityParams.some((param) => params[param] !== undefined)) {
      return {
        id: params.city_id,
        url: decodeURIComponent(params.city_url || ''),
        name: decodeURIComponent(params.city_name || ''),
        ascii_name: decodeURIComponent(params.city_ascii_name || params.slug || ''),
        slug: decodeURIComponent(params.city_ascii_name || params.slug || ''),
        widgetbar_text: decodeURIComponent(params.city_widgetbar_text || ''),
      };
    }

    return null;
  }

  start() {
    // Отправить данные о городе после загрузки
    window.addEventListener('load', () => {
      this.sendWidgetData();
      this.sendBodyHeight();
    });

    // Отправлять данные о высоте виджета по просьбе лоадера `GetHeight`
    this.loaderMessageListener.listen('GetHeight', this.sendBodyHeight.bind(this));

    window.addEventListener('message', (msg) => {
      if (msg.data.action === 'GetHeightForPreview') {
        this.loaderMessageSender.send('NewHeight', {
          view: msg.data.view,
          height: document.body.offsetHeight,
        });
      }
    });

    // Добавлена обработка события изменения размеров окна
    window.addEventListener('resize', () => {
      this.sendBodyHeight();
    });
  }

  sendBodyHeight() {
    const height = document.body.offsetHeight;
    if (height !== this.widgetHeight) {
      this.widgetHeight = height;
      this.logger.log('sendBodyHeight', `Send new height to loader = ${height}`);
      this.loaderMessageSender.send('NewHeight', { height });
    }
  }

  sendWidgetData() {
    if (this.city) {
      const data = {
        city: this.city,
        mode: this.mode,
        widgetInfoString: this.widgetInfoString,
      };

      this.logger.log('sendWidgetData', 'data', data);
      this.loaderMessageSender.send('Load', data);
    }
  }
}
